import { render, staticRenderFns } from "./KaiSpace.vue?vue&type=template&id=e68dffac&scoped=true&"
import script from "./KaiSpace.vue?vue&type=script&lang=ts&"
export * from "./KaiSpace.vue?vue&type=script&lang=ts&"
import style0 from "./KaiSpace.vue?vue&type=style&index=0&id=e68dffac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e68dffac",
  null
  
)

export default component.exports